import * as React from "react";
const SvgFiRrSnowboarding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-snowboarding_svg__a)">
      <path
        fill="#062147"
        d="M23.432 20.4a1 1 0 0 0-1.334.469 2.01 2.01 0 0 1-2.695.926L17 20.727v-4.849a3 3 0 0 0-.968-2.207l-1.954-1.8c-.026-.022-.038-.062-.065-.082l2.16-2.947 6.29 4a1 1 0 0 0 1.074-1.687L13.519 4.782A5 5 0 0 0 10.835 4H9.657a2.98 2.98 0 0 1-2.122-.878L5.707 1.293a1 1 0 1 0-1.414 1.415L6.12 4.536A4.97 4.97 0 0 0 9.657 6h1.156L8.62 8.852A3 3 0 0 0 8 10.681v2.084a.99.99 0 0 1-.553.894l-2.9 1.447a1 1 0 0 0-.09.071L3.16 14.6a2 2 0 0 1-.975-2.656A1 1 0 1 0 .37 11.1a4.01 4.01 0 0 0 1.963 5.318l16.23 7.185A4 4 0 0 0 23.9 21.73a1 1 0 0 0-.468-1.33M8.34 15.448A2.98 2.98 0 0 0 10 12.765v-2.084a1 1 0 0 1 .207-.61L12.8 6.7l1.682 1.07-2.07 2.824a2 2 0 0 0 .34 2.782l1.924 1.771a1 1 0 0 1 .323.735v3.963l-8.191-3.63zM14.91 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-snowboarding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnowboarding;
